/*
 * bc-apply-link.js (20. august 2026, v2; 11. oktober 2026: Google Ads-klikksporing) — SPAM-GATE FOR KLINIKKSØKNADEN.
 *
 * TEMAKOPI «arbeidskopi - B2B-søknad test (U076)», 29.10.2026: søknadslenkene går til det nye skjemaet
 * (bc-b2b-soknad, U070–U076) i stedet for B2B Onboard-proxyen /apps/klinikk-x7k2m, så hele veien kan testes i
 * forhåndsvisningen. Midlertidig adresse: /pages/kontakt?view=b2b-soknad (malen page.b2b-soknad finnes bare i denne
 * kopien). Før kopien publiseres: lag en egen side med malen page.b2b-soknad og sett adressen under til den.
 *
 * Bakgrunn: B2B Onboard-skjemaet lå på appens kjente standard-proxysti
 * (/apps/wholesale-register), og boter som skanner Shopify-butikker for
 * kjente app-stier POST-et rett mot endepunktet (3198 søppelsøknader per
 * 20.08.2026). Mottiltaket er todelt:
 *
 *   1) Proxy-subpathen er byttet til en uforutsigbar sti i B2B Onboards
 *      app-proxy-innstillinger (gjort av Jonas 20.08.2026).
 *   2) Den nye URL-en står ALDRI i HTML-kilden. Alle søknadslenker i temaet
 *      er <a href="#klinikk-soknad">, og navigasjonen skjer først her — og
 *      kun ved et ekte brukerklikk (event.isTrusted). HTML-scrapere ser
 *      aldri adressen, og headless-skript som fyrer syntetiske click-events
 *      kommer heller ikke gjennom.
 *
 * v2: selektoren fanger nå BÅDE [data-bc-apply] OG enhver <a> hvis href
 * slutter på #klinikk-soknad — så nye seksjoner bare trenger å lenke til
 * #klinikk-soknad uten eget attributt. Kjente lenkesteder per 20.08.2026:
 * header.liquid (2), bc-header-utilities, bc-login-gate, bc-hero (default),
 * bc-product-card (gjeste-CTA), bc-stripe-fyll, bc-gate,
 * bc-unapproved-notice.
 *
 * 11.10.2026: Google Ads-konvertering «Søk om klinikkonto» fyres ved ekte
 * klikk på søknadslenkene (måler interesse, ikke fullført søknad — skjemaet
 * ligger på appens egen side utenfor temaet). Navigasjonen venter på
 * event_callback fra gtag, med reserve etter 800 ms slik at søknadslenken
 * aldri blir blokkert (f.eks. av samtykke eller annonseblokkere).
 *
 * VED NYTT BYTTE AV PROXY-SUBPATH: oppdater de to konstantene under. De er
 * base64 av stien, delt i to (så selve b64-strengen heller ikke kan
 * grep-es i ett stykke):
 *   python3 -c "import base64; e=base64.b64encode('/apps/NY-STI'.encode()).decode(); print(e[:12], e[12:])"
 */
(function () {
  // Temakopi U076: /pages/kontakt?view=b2b-soknad (B2B Onboard var 'L2FwcHMva2xp' + 'bmlray14N2sybQ==').
  var p1 = 'L3BhZ2VzL2tv';
  var p2 = 'bnRha3Q/dmlldz1iMmItc29rbmFk';
  var AW_SEND_TO = 'AW-11378806384/03gwCMq9kZkdEPCc67Eq';

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest
      ? e.target.closest('[data-bc-apply], a[href$="#klinikk-soknad"]')
      : null;
    if (!el) return;
    e.preventDefault();
    if (!e.isTrusted) return;

    var url = atob(p1 + p2);
    var went = false;
    function go() {
      if (went) return;
      went = true;
      window.location.assign(url);
    }

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', { send_to: AW_SEND_TO, event_callback: go });
        setTimeout(go, 800);
      } else {
        go();
      }
    } catch (err) {
      go();
    }
  });
})();